/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_GroupInputs */

const vi_customer_group = /** @type {(inputs: Customer_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhóm khách hàng`)
};

/**

* @param {Customer_GroupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group = /** @type {((inputs?: Customer_GroupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_GroupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group(inputs)
});